import styled from "styled-components";

export const Content = styled.div`
  fill: ${({ theme }) => theme.colors.green};
  width: 100%;
  max-width: ${({ expandContainer }) => (expandContainer ? "40rem" : "32.8rem")};
  margin: auto;
`;

export const Logo = styled.div`
  text-align: center;

  svg {
    height: 6.4rem;
    vertical-align: middle;
  }
`;

export const Form = styled.form`
  margin: 2.4rem 0;
  padding: 2.4rem 3.2rem;
  border-radius: 0.4rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.grayLighter};
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Title = styled.h1`
  font-size: 2.4rem;
  font-weight: 600;
  line-height: 3rem;
  margin: 0 0 2.4rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.grayDark};
`;

export const FormGroup = styled.div`
  margin-bottom: 1.6rem;

  ${({ $top }) =>
    $top &&
    `
    margin-bottom: 0;
    margin-top: 1.6rem;
  `}
`;

export const Divider = styled.div`
  display: block;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.6rem;
  letter-spacing: 0.05rem;
  color: ${({ theme }) => theme.colors.gray};
  text-transform: uppercase;
  text-align: center;
  position: relative;

  &:before {
    content: "";
    width: 100%;
    height: 0.2rem;
    background-color: ${({ theme }) => theme.colors.grayLighter};
    transform: translateY(-50%);
    position: absolute;
    top: 50%;
    left: 0;
    z-index: 0;
  }

  span {
    padding: 0 1.2rem;
    background-color: ${({ theme }) => theme.colors.white};
    position: relative;
    z-index: 1;
  }
`;

export const Label = styled.label`
  display: inline-block;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.6rem;
  margin-bottom: 0.3rem;
  color: #4d5a6a;
  vertical-align: middle;
  cursor: pointer;

  @media (max-width: 578px) {
    font-size: 1.3rem;
    font-weight: 700;
    line-height: 1.7rem;
  }
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  font-size: 1.4rem;
  line-height: 2rem;
  min-width: 0;
  padding: 0.7rem 1.2rem;
  border-radius: 0.4rem;
  border: 0.1rem solid "#e2e5e8";
  background-color: #fff;
  color: #212d3b;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none;

  &:active,
  &:focus {
    border-color: ${({ theme }) => theme.styleGuide.colors.helix['brand']};
    outline: 1px solid ${({ theme }) => theme.styleGuide.colors.helix['brand']};
  }

  &::placeholder {
    color: "#9ba4b0";
  }
`;

export const SubmitContainer = styled.div`
  fill: ${({ theme }) => theme.colors.green};
  text-align: center;
`;

export const SubmitButton = styled.button`
  width: 100%;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  min-height: 36px;
  max-height: 36px;
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
  box-sizing: border-box;
  white-space: nowrap;
  box-shadow:
    0px 0px 2px rgba(0, 0, 0, 0.2),
    0px 1px 2px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.styleGuide.colors.helix['brand']};
  color: #f3f4f6;
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.styleGuide.colors.helix['light-green']};
    color: #f3f4f6;
  }

  &:active {
    background-color: ${({ theme }) => theme.styleGuide.colors.helix['dark-green']};
  }

  &[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const Reset = styled.div`
  text-align: center;
  padding-top: 1rem;

  a {
    font-size: 1.2rem;
    font-weight: 600;
    line-height: 1.6rem;
    color: ${({ theme }) => theme.styleGuide.colors.helix['brand']};
  }
`;

export const LwSso = styled.a`
  display: flex;
  align-items: stretch;
  border: 0.1rem solid ${({ theme }) => theme.styleGuide.colors.helix['brand']};
  border-radius: 0.6rem;
  cursor: pointer;
  overflow: hidden;

  :hover {
    border: 0.1rem solid ${({ theme }) => theme.styleGuide.colors.helix['light-green']};
    text-decoration: none;

    .sso-icon {
      background-color: ${({ theme }) => theme.styleGuide.colors.helix['light-green']};
    }

    .sso-text {
      background-color: ${({ theme }) => theme.styleGuide.colors.helix['light-green']};
    }
  }

  &.btn-md {
    max-width: 28rem;
    margin: 0 auto;
  }

  .sso-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 3.6rem;
    background-color: ${({ theme }) => theme.styleGuide.colors.helix['brand']};
    position: relative;

    svg {
      width: 2rem;
      height: 2rem;
      fill: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .sso-text {
    display: block;
    flex-grow: 1;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2rem;
    padding: 0.8rem;
    color: #fff;
    text-align: center;
    background-color: ${({ theme }) => theme.styleGuide.colors.helix['brand']};
  }
`;

export const CasSso = styled.a`
  display: flex;
  align-items: stretch;
  border: 0.1rem solid ${({ theme }) => theme.styleGuide.colors.suite[600]};
  border-radius: 0.4rem;
  cursor: pointer;

  :hover {
    text-decoration: none;
  }

  .sso-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 3.6rem;
    background-color: ${({ theme }) => theme.styleGuide.colors.suite[600]};

    svg {
      width: 1.8rem;
      height: 1.4rem;
      fill: #fff;
    }
  }

  .sso-text {
    display: block;
    flex-grow: 1;
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 2rem;
    padding: 0.8rem 1rem;
    color: ${({ theme }) => theme.styleGuide.colors.suite[600]};
    text-align: center;
  }
`;

export const Flash = styled.div`
  font-size: ${({ $error }) => ($error ? "1.2rem" : "1.3rem")};
  line-height: 1.8rem;
  display: flex;
  align-items: center;
  justify-content: ${({ $center }) => ($center ? "center" : "flex-start")};
  font-weight: 600;
  padding: 0.8rem;
  border-radius: 0.4rem;
  color: ${({ $error, theme }) =>
    $error ? theme.colors.redLight : theme.styleGuide.colors.helix['brand']};
  background-color: ${({ $error, theme }) => ($error ? "#fbdcdc" : theme.styleGuide.colors.helix['white-green'])};

  svg {
    flex-shrink: 0;
    margin-right: 0.8rem;
    width: ${({ $error }) => ($error ? "2.4rem" : "1.6rem")};
    height: ${({ $error }) => ($error ? "2.4rem" : "1.6rem")};
  }
    
  svg path {
    color: ${({ $error, theme }) =>
      $error ? theme.colors.redLight : theme.styleGuide.colors.helix['light-green']} !important;
    fill: ${({ $error, theme }) =>
      $error ? theme.colors.redLight : theme.styleGuide.colors.helix['light-green']} !important;
  }
`;

export const Text = styled.p`
  font-size: 1.2rem;
  line-height: 1.8rem;
  margin: 0 0 2.4rem;
`;
